module.exports = "pegasus_template/assets/background-patterns/contemporary-china.png";